<template>
    <div class="role_management">
        <!--  组管理  -->
        <div class="search_data">
            <div class="item_title">Status:</div>
            <div class="item_select">
                <el-select clearable v-model="selectValue" placeholder="All" @change="getCompanyGroup">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    ></el-option>
                </el-select>
            </div>
            <div class="item_keyword">
                <el-input v-model="inputValue" placeholder="Please Enter Keywords"></el-input>
            </div>
            <div class="item_submit" @click="searchData">Search</div>

            <div class="add_new" @click="addNew">
                <span class="el-icon-circle-plus add_new_icon">&nbsp;Add New</span>
            </div>
        </div>
        <!-- 数据表格 -->
        <div class="table">
            <TableTem
                    size="mini"
                    :isSelection="false"
                    :isIndex="true"
                    :isPagination="true"
                    :isHandle="true"
                    :tableData="tableData"
                    :tableCols="GroupTable"
                    :pagination="pagination"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                    @switchVal3="switchVal3"
                    @passRowData="passRowData"
            ></TableTem>
        </div>
        <!-- // 添加组 || 编辑组 -->
        <GroupDialog
                @visible="visible"
                :passVisible="roleVisible"
                :title="RoleTitle"
                :selectValue="selectValue"
                :inputValue="inputValue"
                @submitForm="submitForm"
                :editId="editId"
                :editMessage="editMessage"
        ></GroupDialog>
    </div>
</template>

<script>
    import TableTem from "./TableTem.vue";
    import qs from "qs";
    import {GroupTable} from "@/conf/Backstage.js";
    import GroupDialog from "./GroupDialog.vue";
    import {queryGroup, deleteGroup, addGroup, groupList, updateGroup} from "@/common/js/http/version3Api.js";

    export default {
        name: "Group",
        components: {
            TableTem,
            GroupDialog
        },
        data() {
            return {
                roleVisible: false,
                RoleTitle: "",
                editMessage: [],
                editId: "",
                GroupTable,
                groupId: "",
                tableData: [],
                pagination: {},
                options: [
                    {
                        value: "1",
                        label: "On"
                    },
                    {
                        value: "0",
                        label: "Off"
                    },
                    {
                        value: "",
                        label: "All"
                    }
                ],
                selectValue: "",
                inputValue: "",
                data: {},
                switchId: "",
                switchState: "",
                isEdit: false
            };
        },
        created() {
            this.getCompanyGroup();
        },
        methods: {
            submitForm(ruleForm, permissionIds) {
                this.data = {
                    ENName: ruleForm.englishName,
                    ZHName: ruleForm.chineseName,
                    groupDesc: ruleForm.groupDesc,
                    status: ruleForm.status,
                    id: this.editId,
                    brandToken: localStorage.getItem('brand-token')
                }
                if (this.isEdit === true) {
                    this.modify();
                } else {
                 
                    this.addNewGroup();
                }
            },
            //开关状态
            switchVal3(row) {
                this.switchId = row.id;
                this.switchState = row.status;
                let data = {
                    id: this.switchId, 
                    status: this.switchState, 
                    brandToken: localStorage.getItem('brand-token')
                }
                updateGroup(JSON.stringify(data)).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            type: "success",
                            message: res.message
                        });
                    }
                })
            },

            //添加组信息
            async addNewGroup() {
                let res = await addGroup(JSON.stringify(this.data));
                if (res.code == 200) {
                    this.$message({
                        message: res.message,
                        type: "success"
                    });
                    this.getCompanyGroup();
                }
            },
            select(row) {
            },
            visible(val, newsValue) {
                this.roleVisible = val;
                this.editId = "";
            },
            // 搜索数据
            searchData() {
                this.getCompanyGroup();
            },
            deleteRow(index, rows) {
            },
            querySwitchVal(val) {
            },
            scopeData(rowData) {
            },
            // 添加组
            addNew() {
                this.roleVisible = true;
                this.isEdit = false;
                this.RoleTitle = "Creating Group";
                this.editMessage = []
            },
            // 获取 表格传递的数据
            async passRowData(rowData) {
                this.groupId = rowData.rowData.id;

                if (rowData.button == "delete") {
                    this.$confirm("此操作将永久删除该组, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                        .then(() => {
                            deleteGroup({id: this.groupId}).then(res => {
                                if (res.code === 200) {
                                    this.$message({
                                        type: "success",
                                        message: res.message
                                    });
                                    this.getCompanyGroup();
                                }
                            });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消删除"
                            });
                        });
                    //this.delRole();
                } else {
                    this.editId = rowData.rowData.id;
                    this.getOnesList();
                }

                let buttonType = rowData.button;
                switch (buttonType) {
                    case "edit":
                        this.roleVisible = true;
                        this.isEdit = true;
                        this.RoleTitle = "Edit Group";
                        break;
                }
            },
            handleCurrentChange(val) {
                this.pagination.pageNum = val;
                this.getCompanyGroup();
            },
            handleSizeChange(val) {
                this.pagination.pageSize = val;
            },

            //获取组列表
            getCompanyGroup() {
                let data = {
                    groupName: this.inputValue,
                    status: this.selectValue,
                    pageNum: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize
                }
                queryGroup(data).then(res => {
                    this.tableData = res.result.list;
                    this.pagination.total = res.result.total;
                    this.pagination.pageSize = res.result.pageSize;
                    this.pagination.pageNum = res.result.pageNum;

                })
            },
            //查询详细信息
            getOnesList() {
                groupList({id: this.groupId}).then(res => {
                    this.editMessage = res.result;
                })
            },
            //修改组信息
            async modify() {
                let res = await updateGroup(this.data);
                this.$message({
                    message: res.message,
                    type: 'success'
                })
                this.getCompanyGroup();
            }
        },
        watch: {
            editMessage: {
                handler(newValue) {
                },
                deep: true
            },
            switchId: {
                handler(newValue) {
                    this.switchId = newValue;
                },
                deep: true
            },
            switchState: {
                handler(val) {
                    this.switchState = val;
                },
                deep: true
            }
        }
    };
</script>

<style scoped>
    .search_data > div {
        display: inline-block;
        margin-right: 15px;
        vertical-align: middle;
    }

    .search_data >>> .el-input__inner,
    .search_data >>> .el-input__icon {
        height: 32px;
        line-height: 32px;
    }

    .search_data .item_submit {
        cursor: pointer;
        width: 74px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
        color: #0078ff;
        border-radius: 2px;
        border: 1px solid #0078FF;
    }

    .role_management {
        padding: 10px;
    }

    .add_new {
        float: right;
    }

    .add_new span {
        cursor: pointer;
        user-select: none;
        width: 90px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: rgba(0, 0, 0, 0);
        border: 1px solid #0078ff;
        font-size: 14px;
        color: #0078ff;
        border-radius: 2px;
    }
</style>